import {useId, useState, type FormEvent, type ChangeEvent} from 'react';
import {CloseIcon, SearchIcon} from '@prtimes-basis/icons';
import styles from './search-form.module.css';

type Props = {
  readonly isExpanded: boolean;
  readonly setIsExpanded: (value: boolean) => void;
};

export function SearchForm({isExpanded, setIsExpanded}: Props) {
  // フォーム
  const [keyword, setKeyword] = useState('');
  const onChange = ({target: {value}}: ChangeEvent<HTMLInputElement>) => {
    setKeyword(value);
  };

  const onSubmit = (event: FormEvent) => {
    if (keyword === '') {
      event.preventDefault();
    }
  };

  const formId = useId();

  // アニメーション用に width を制御するための state
  const [isShown, setIsShown] = useState(isExpanded);
  const expandForm = () => {
    setIsExpanded(true);
    // 一度キューに積むことで isExpanded による再レンダリングの後に更新する
    setTimeout(() => {
      setIsShown(true);
    }, 0);
  };

  const collapseForm = () => {
    setIsShown(false);
    // アニメーションが終わってから DOM を非表示にする
    setTimeout(() => {
      setIsExpanded(false);
    }, 200);
  };

  return (
    <div className={styles.search}>
      <button
        type='button'
        className={styles.button}
        aria-label='検索バーを表示する'
        aria-controls={formId}
        aria-expanded={isExpanded}
        disabled={isExpanded}
        onClick={expandForm}
      >
        <SearchIcon variant='white' width={25} height={25} />
      </button>

      {isExpanded ? (
        <form
          action='/main/action.php'
          id={formId}
          className={styles.form}
          style={{width: isShown ? 270 : 0}}
          onSubmit={onSubmit}
        >
          <input type='hidden' name='run' value='html' />
          <input type='hidden' name='page' value='searchkey' />
          <input
            autoFocus
            type='text'
            name='search_word'
            placeholder='キーワードで検索'
            value={keyword}
            className={styles.input}
            onChange={onChange}
          />
          <input type='hidden' name='search_pattern' value='1' />
          <button
            type='button'
            className={styles.collapseIcon}
            aria-label='検索バーを閉じる'
            onClick={collapseForm}
          >
            <CloseIcon variant='white' />
          </button>
        </form>
      ) : null}
    </div>
  );
}
